import dataService from './data-service';

export default class API {
  constructor() {}

  activateUserCar() {
    return dataService.post('/activateUserCar/');
  }

  checkToken() {
    return dataService.post('/checkToken/');
  }

  getActiveCars() {
    return dataService.post('/getActiveCars/');
  }

  getAllCarsInfo() {
    return dataService.get('/getAllCarsInfo/');
  }

  getArchivedCars() {
    return dataService.post('/getArchivedCars/');
  }

  getBrands() {
    return dataService.post('/getBrands/');
  }

  getCarComparisonUrl() {
    return dataService.post('/getCarComparisonUrl/');
  }

  getCarContactInfo(data) {
    return dataService.post('/getCarContactInfo/', data);
  }

  getNotificationsStatus() {
    return dataService.post('/getNotificationsStatus/');
  }

  updateNotificationsStatus(data) {
    return dataService.post('/updateNotificationsStatus/', data);
  }

  getCarMaintenanceHistory(data) {
    return dataService.post('/getCarMaintenanceHistory/', data);
  }

  getMaintenanceURL(data) {
    return dataService.post('/getMaintenanceURL/', data);
  }

  getCarServiceContracts(data) {
    return dataService.post('/getCarServiceContracts/', data);
  }

  getCarsTradeEstimate() {
    return dataService.post('/getCarsTradeEstimate/');
  }

  getCities() {
    return dataService.post('/getCities/');
  }

  getEserviceReservations() {
    return dataService.post('/getEserviceReservations/');
  }

  getNotificationStatus() {
    return dataService.post('/getNotificationStatus/');
  }

  getStores() {
    return dataService.post('/getStores/');
  }

  getUserEvents() {
    return dataService.post('/getUserEvents/');
  }

  getUserMessages() {
    return dataService.post('/getUserMessages/');
  }

  getUserRecommendations() {
    return dataService.post('/getUserRecommendations/');
  }

  getUserTestdrives() {
    return dataService.post('/getUserTestdrives/');
  }

  getUserVouchers() {
    return dataService.post('/getUserVouchers/');
  }

  removeUserCar() {
    return dataService.post('/removeUserCar/');
  }

  setMessageRead(data) {
    return dataService.post('/setMessageRead/', data);
  }

  setVoucherDone() {
    return dataService.post('/setVoucherDone/');
  }

  updateCarContactInfo() {
    return dataService.post('/updateCarContactInfo/');
  }

  updateCarKMs(data) {
    return dataService.post('/updateCarKMs/', data);
  }

  updateCarTradeEstimate(data) {
    return dataService.post('/updateCarTradeEstimate/', data);
  }

  updateMarketingPreferences(data) {
    return dataService.post('/updateMarketingPreferences/', data);
  }

  updateNotificationStatus() {
    return dataService.post('/updateNotificationStatus/');
  }

  updatePassword(data) {
    return dataService.post('/updatePassword/', data);
  }

  updateUserBrands(data) {
    return dataService.post('/updateUserBrands/', data);
  }

  updateUserInfo(data) {
    return dataService.post('/updateUserInfo/', data);
  }

  getUserInfo() {
    return dataService.post('/getUserInfo/');
  }

  getBrandPhonenumbers(data) {
    return dataService.post('/getBrandPhonenumbers/', data);
  }

  getCarSearches() {
    return dataService.post('/getCarSearches/');
  }

  removeCarSearch(data) {
    return dataService.post('/removeCarSearch/', data);
  }

  getArticles(data) {
    return dataService.post('/getArticles/', data);
  }

  removeCar(data) {
    return dataService.post('/removeCar/', data);
  }

  sendFeedback(data) {
    return dataService.post('/sendFeedback/', data);
  }

  addCar(data) {
    return dataService.post('/addCar/', data);
  }

  addTestdriveReport(data) {
    return dataService.post('/addTestdriveReport/', data);
  }

  getOmaLaakkonenContestStatus() {
    return dataService.post('/getOmaLaakkonenContestStatus/');
  }

  participateOmaLaakkonenContest() {
    return dataService.post('/participateOmaLaakkonenContest/');
  }

  registerUser(data) {
    return dataService.post('/registerUser/', data);
  }

  confirmUser(data) {
    return dataService.post('/confirmUser/', data);
  }

  getActivationLinkEmail(data) {
    return dataService.post('/getActivationLinkEmail/', data);
  }

  getFiksudiili(data) {
    return dataService.post('/getFiksudiili/', data);
  }

  getFiksudiiliRecommendedCars(data) {
    return dataService.post('/getFiksudiiliRecommendedCars/', data);
  }

  getFiksudiiliFaq(data) {
    return dataService.post('/getFiksuDiiliFaq/');
  }
}
